export default "__VITE_ASSET__Deuz9t5O__"